<template>
  <el-descriptions
    id="infoDesc"
    size="medium"
    border
    :labelStyle="{ 'min-width': '100px' }"
  >
    <div slot="title">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </div>
    <el-descriptions-item label="单号">
      <span v-fmtype="head.orderNo ? '' : 'info'">
        {{ head.orderNo || "暂无" }}
      </span>
    </el-descriptions-item>
    <el-descriptions-item label="单据日期" span="2">
      {{ head.orderDate }}
    </el-descriptions-item>
    <el-descriptions-item label="所选商品" span="3">
      <el-table
        :data="itemList || []"
        stripe
        :row-key="
          (row) => {
            return row.id + row.lastEditTime;
          }
        "
        height="300px"
        max-height="500px"
        style="max-width: 100%"
      >
        <el-table-column
          prop="itemNo"
          label="序号"
          width="50"
          align="center"
          header-align="center"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="商品图片"
          width="120"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <CommodityImage
              size="60px"
              :commodity="scope.row.snapshot.commodity"
              :commoditySpec="scope.row.snapshot.commoditySpec"
            ></CommodityImage>
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品信息"
          min-width="200"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div style="line-height: 1.4em">
              <div style="font-size: 1.1em">
                {{ scope.row.snapshot.commodity.name }}
              </div>
              <div class="fm-mt-5">
                {{
                  "分类：" + scope.row.snapshot.commodity.commodityCategory.name
                }}
              </div>
              <div>{{ "单位：" + scope.row.commodity.unit }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="snapshot.commoditySpec.specName"
          label="规格名称"
          min-width="100"
          align="left"
          header-align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content" style="max-width: 300px">
                {{ scope.row.snapshot.commoditySpec.specName }}
              </div>
              <span class="fm-line-3">{{
                scope.row.snapshot.commoditySpec.specName
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="retailPrice"
          label="规格采购价"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.retailPrice"></FmAmount>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemQuantity"
          label="购买数量"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.itemQuantity + scope.row.snapshot.commodity.unit }}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemAmount"
          label="金额"
          width="150"
          align="left"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="fm-flex">
              总采购价：
              <FmAmount
                :amount="scope.row.commodityRetailTotalAmount"
              ></FmAmount>
            </div>
            <div class="fm-flex">
              折扣金额：<FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </div>
            <div class="fm-flex">
              成交价：<FmAmount :amount="scope.row.itemAmount"></FmAmount>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-descriptions-item>
    <el-descriptions-item label="单据金额" span="3">
      <div class="fm-flex">
        <FmAmount :amount="head.orderAmount"></FmAmount>
        （总采购价：<FmAmount
          :amount="head.commodityRetailTotalAmount"
        ></FmAmount
        >，优惠金额：<FmAmount :amount="head.disCountAmount"></FmAmount
        >，采购成交价：<FmAmount :amount="head.commodityRetailAmount"></FmAmount
        >）
      </div>
    </el-descriptions-item>
    <el-descriptions-item label="付款凭证" span="3">
      <OrderImageList
        :list="head.payVoucherImageList"
        name="付款凭证图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="付款备注" span="3">
      <span v-fmtype="head.payRemark ? '' : 'warning'">{{
        head.payRemark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="纸质单据" span="3">
      <OrderImageList
        :list="head.paperOrderImageList"
        name="纸质单据图片"
      ></OrderImageList>
    </el-descriptions-item>
    <el-descriptions-item label="备注" span="3">
      <span v-fmtype="head.remark ? '' : 'warning'">{{
        head.remark || "——"
      }}</span>
    </el-descriptions-item>
    <el-descriptions-item label="制单信息" span="3">
      <p>制单人：{{ head.creator.name }}</p>
      <p v-if="orderConfig.displayTime">制单时间：{{ head.createTime }}</p>
    </el-descriptions-item>
  </el-descriptions>
</template>

<script>
export default {
  name: "Rterpv2WebPurchaseOrderInfo",
  props: {
    orderInfo: {
      type: [Object],
      default: null,
    },
  },
  watch: {
    orderInfo: {
      handler(newVal, val) {
        if (newVal) {
          this.showOrderInfo = { ...newVal, headVo: newVal.head };
          setTimeout(() => {
            this.getOrderConfig();
            this.getOrderInfo();
          }, 10);
        }
      },
      immediate: true,
    },
  },
  computed: {
    head() {
      return this.showOrderInfo && this.showOrderInfo.headVo
        ? this.showOrderInfo.headVo
        : {};
    },
    itemList() {
      if (this.showOrderInfo && this.showOrderInfo.itemList) {
        let arr = this.showOrderInfo.itemList;
        arr.sort((a, b) => a.itemNo - b.itemNo);
        arr.forEach((item, index) => {
          item.itemNo = index + 1;
        });
        return arr;
      }
      return [];
    },
  },
  data() {
    return {
      showOrderInfo: null,
      orderConfig: {
        displayTime: true,
      },
    };
  },

  mounted() {},

  methods: {
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:PurchaseOrder:DisplayCreateTime",
      ]);
      if (res && res.success) {
        let displayTimeIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:DisplayCreateTime"
        );
        if (
          displayTimeIndex > -1 &&
          res.data[displayTimeIndex].value == "false"
        ) {
          this.orderConfig.displayTime = false;
        }
      }
    },
    async getOrderInfo() {
      let requestRes = await this.$api.purchaseOrder_findVoById(
        this.orderInfo.head.id,
        {
          showLoading: true,
          loadingParam: {
            target: "#infoDesc",
            lock: true,
          },
        }
      );
      if (requestRes && requestRes.success) {
        this.showOrderInfo = requestRes.data;
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrderInfo.vue